import { RunStatusBadge } from "@/components/desk-suggestions/run-status-badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatDateTime } from "@/lib/date-utils";
import type { DeskImprovementRunSummary } from "@/lib/types/desk-improvements";

interface ImprovementRunsTableProps {
  runs: DeskImprovementRunSummary[];
  selectedRunId: string;
  onSelect: (runId: string) => void;
}

export function ImprovementRunsTable({
  runs,
  selectedRunId,
  onSelect,
}: ImprovementRunsTableProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Status</TableHead>
          <TableHead>Started</TableHead>
          <TableHead>Finished</TableHead>
          <TableHead className="text-right">Tickets</TableHead>
          <TableHead>
            <span className="sr-only">Actions</span>
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {runs.map((run) => {
          const selected = run.id === selectedRunId;
          return (
            <TableRow
              key={run.id}
              data-state={selected ? "selected" : undefined}
              aria-current={selected ? "true" : undefined}
              className="cursor-pointer"
              onClick={() => {
                onSelect(run.id);
              }}
            >
              <TableCell>
                <RunStatusBadge status={run.status} />
              </TableCell>
              <TableCell>{formatDateTime(run.created_at)}</TableCell>
              <TableCell>
                {run.finished_at ? formatDateTime(run.finished_at) : "—"}
              </TableCell>
              <TableCell className="text-right">
                {run.ticket_count?.toLocaleString() ?? "—"}
              </TableCell>
              <TableCell className="text-right">
                <Button
                  size="sm"
                  variant={selected ? "secondary" : "outline"}
                  aria-pressed={selected}
                  aria-label={`Review run from ${formatDateTime(run.created_at)}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(run.id);
                  }}
                >
                  Review
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
